export const AppleLogo = () => (
  <svg
    aria-labelledby='appleLogoTitle'
    fill='none'
    height='24'
    role='img'
    viewBox='0 0 24 24'
    width='24'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title id='appleLogoTitle'>Apple logo</title>
    <g clipPath='url(#clip0_11194_5357)'>
      <path
        d='M16.7729 0.0120105C16.7219 -0.0449895 14.8844 0.0345106 13.2854 1.77001C11.6864 3.50401 11.9324 5.49301 11.9684 5.54401C12.0044 5.59501 14.2484 5.67451 15.6809 3.65701C17.1134 1.63951 16.8239 0.0705105 16.7729 0.0120105ZM21.7439 17.6115C21.6719 17.4675 18.2564 15.7605 18.5744 12.4785C18.8924 9.19651 21.0869 8.29501 21.1214 8.19751C21.1559 8.10001 20.2259 7.01251 19.2404 6.46201C18.5167 6.07426 17.7159 5.85192 16.8959 5.81101C16.7339 5.80651 16.1714 5.66851 15.0149 5.98501C14.2529 6.19351 12.5354 6.86851 12.0629 6.89551C11.5889 6.92251 10.1789 6.11251 8.66239 5.89801C7.69189 5.71051 6.66289 6.09451 5.92639 6.39001C5.19139 6.68401 3.79339 7.52101 2.81539 9.74551C1.83739 11.9685 2.34889 15.4905 2.71489 16.5855C3.08089 17.6805 3.65239 19.4715 4.62439 20.7795C5.48839 22.2555 6.63439 23.28 7.11289 23.628C7.59139 23.976 8.94139 24.207 9.87739 23.7285C10.6304 23.2665 11.9894 23.001 12.5264 23.0205C13.0619 23.04 14.1179 23.2515 15.1994 23.829C16.0559 24.1245 16.8659 24.0015 17.6774 23.6715C18.4889 23.34 19.6634 22.083 21.0344 19.5345C21.5544 18.3495 21.7909 17.7085 21.7439 17.6115Z'
        fill='black'
      />
    </g>
    <defs>
      <clipPath id='clip0_11194_5357'>
        <rect
          fill='white'
          height='24'
          width='24'
        />
      </clipPath>
    </defs>
  </svg>
);
